/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, leftMetric: NonNullable<unknown>, leftValue: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Stake_Or_Hashrate_Different_No_RightInputs */



/**
* | output |
* | --- |
* | "{leftChain} {leftMetric} is {leftValue}, while {rightChain} has no data" |
*
* @param {Chain_Page_Compare_Stake_Or_Hashrate_Different_No_RightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_stake_or_hashrate_different_no_right = /** @type {((inputs: Chain_Page_Compare_Stake_Or_Hashrate_Different_No_RightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Stake_Or_Hashrate_Different_No_RightInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} ${i?.leftMetric} is ${i?.leftValue}, while ${i?.rightChain} has no data`)
});